<div class="container-fluid g-0">
    <app-header (sideNavToggled)="setSideNavPinned($event);"></app-header>
    <main>
        <app-side-nav [sideNavStatus]="isSideNavOpen" [ngClass]="{'app-side-nav-open': isSideNavOpen}"
            (sideNavOpenRequested)="setSideNavPinned(true)"
            (mouseenter)="setSideNavHovered(true)" (mouseleave)="setSideNavHovered(false)"></app-side-nav>
        @if (isSideNavOpen) {
        <div class="side-nav-backdrop d-md-none" (click)="setSideNavPinned(false)"></div>
        }
        <div class="display-area p-3" [ngClass]="{'display-area-shrink': isSideNavOpen}">
            <router-outlet></router-outlet>
        </div>
    </main>
</div>
